var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleExclusions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 0H0V19.6H21.6V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7 11.6H18V13.6H16V11.8C15.3 11.8 14.6 11.6 14 11.4V17.6H6V3.60001H10.1C10.3 2.90001 10.7 2.20001 11.1 1.60001H1C0.5 1.60001 0 2.00001 0 2.60001V18.6C0 19.1 0.4 19.6 1 19.6H19C19.5 19.6 20 19.2 20 18.6V10.5C19.3 11 18.5 11.4 17.7 11.6ZM4 17.6H2V15.6H4V17.6ZM4 13.6H2V11.6H4V13.6ZM4 9.60001H2V7.60001H4V9.60001ZM4 5.60001H2V3.60001H4V5.60001ZM18 17.6H16V15.6H18V17.6Z",
    fill: "#008662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2 10.8C13.2 10.8 10.8 8.4 10.8 5.4C10.8 2.4 13.2 0 16.2 0C19.2 0 21.6 2.4 21.6 5.4C21.6 8.4 19.2 10.8 16.2 10.8ZM16.2 9.7C18.6 9.7 20.5 7.8 20.5 5.4C20.5 3 18.6 1.1 16.2 1.1C13.8 1.1 11.9 3 11.9 5.4C11.9 7.8 13.8 9.7 16.2 9.7ZM16.2 4.6L17.7 3.1L18.5 3.9L17 5.4L18.5 6.9L17.7 7.7L16.2 6.2L14.7 7.7L13.9 6.9L15.4 5.4L13.9 3.9L14.7 3.1L16.2 4.6Z",
    fill: "#008662"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleExclusions);
export default __webpack_public_path__ + "static/media/TitleExclusions.97f6cebaa3c5e25176c2dc96a4797bd7.svg";
export { ForwardRef as ReactComponent };